import { useState, useEffect } from "react";
import { Button, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Popup from "../../common/modal/Popup";
import Loader from "../../common/loader/Loader";
import { deleteTime } from "../../../store/actions/dashboardsAction";
const DeleteTimePopup = ({
  deleteRec,
  onHide,
  deleteModalShow,
  setDeleteModalShow,
}) => {
  const {
    isRecordUpdated,
    error: apiError,
    isLoader,
  } = useSelector((state) => {
    return state.dashboards;
  });
  const [isAction, setIsAction] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const dispatch = useDispatch();

  const submitHandler = (mode) => {
    setIsAction(true);
    return dispatch(
      deleteTime({
        timeId: deleteRec,
      })
    );
  };
  useEffect(() => {
    if (isRecordUpdated) {
      setIsDone(true);
      onHide();
      setDeleteModalShow(false);
    }
  }, [isRecordUpdated]);

  return (
    <>
      <Popup
        onHide={() => onHide()}
        size="md"
        show={deleteModalShow}
        title={"Delete Auto Report"}
        footer={
          <>
            <Button
              variant="outline-secondary model-btn"
              onClick={(e) => onHide()}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler()}
            >
              Confirm
            </Button>
          </>
        }
      >
        {isLoader && <Loader />}
        {apiError && (
          <Alert variant={"danger"}>
            {apiError?.message || "Access denied! Please try again"}
          </Alert>
        )}
        <div style={{ textAlign: "center" }}>
          {"Are you sure you want to delete this auto report?"}
        </div>
      </Popup>
    </>
  );
};

export default DeleteTimePopup;
